import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '../modules/crud';
import { Partner } from './partner.model';
import { PrestationItem } from './prestation-availability.model';
import { Prestation } from './prestation.model';
import { Stay } from './stay.model';
import { User } from './user.model';

export enum PrestationReservationStatus {
    Validated = 'validated',
    Refused = 'refused',
    Pending = 'pending',
};

export interface wishedItems {
    item: PrestationItem;
    quantity: number;
}

@CwtModel({ name: 'prestation-reservation', path: '/prestation-reservation' })
export class PrestationReservation extends ApiData {
    user: User;
    partner: Partner;
    prestation: Prestation;
    creationDate: number;
    date: number;
    time: number;
    location: string;
    status: PrestationReservationStatus;
    userComment: string;
    partnerComment: string;
    stay: Stay;
    wishedItems: wishedItems[];
}